import React from 'react';
import Gallery from '../components/Gallery';
import styles from '../styles/Design_Lab.module.css';

const Design_Lab = () => (
    <div className={styles.pageContainer}>
        <Gallery />
    </div>
);

export default Design_Lab;
